import { render, staticRenderFns } from "./userCoin.vue?vue&type=template&id=e90c6cb6&scoped=true&"
import script from "./userCoin.vue?vue&type=script&lang=js&"
export * from "./userCoin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e90c6cb6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e90c6cb6')) {
      api.createRecord('e90c6cb6', component.options)
    } else {
      api.reload('e90c6cb6', component.options)
    }
    module.hot.accept("./userCoin.vue?vue&type=template&id=e90c6cb6&scoped=true&", function () {
      api.rerender('e90c6cb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpGameData/userAnalysis/userCoin.vue"
export default component.exports